import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import PropTypes from "prop-types";

import { GET_NEWS } from "../../Graphql/queries/queryGetNews";
import { MUTATION_CREATE_NEWS } from "../../Graphql/mutations/mutationCreateNews";
import { useToastError } from "../../Hooks/useToastError";
import { useToastLoading } from "../../Hooks/useToastLoading";
import { useToastSuccessful } from "../../Hooks/useToastSuccessful";
import IconClose from "../../components/Icons/IconClose";
import PrimaryNormal from "../../components/buttons/PrimaryNormal";

import {
  Modal,
  Content,
  ContainerInfo,
  Title,
  Description,
  DivUp,
  DivDown,
  ContainerNote,
  Close,
  TextArea,
} from "./styles";

const ModalNews = ({ modalOpen, setModalOpen, healthId }) => {
  const [description, setDescription] = useState("");
  const toastSuccessful = useToastSuccessful();

  const { error, data, loading, refetch } = useQuery(GET_NEWS, {
    variables: {
      healthId: healthId,
    },
  });

  const [createNew, { error: errorMutation, loading: loadingMutation }] = useMutation(MUTATION_CREATE_NEWS, {
    onCompleted: () => {
      toastSuccessful("Novedad creada con éxito.");
      setDescription("");
      refetch();
    },
    onError: (err) => console.error(err),
  });

  useToastError(error || errorMutation);
  useToastLoading(loadingMutation, "Creando...");

  if (loading) {
    return <div />;
    // return <AnimationLoading />
  }

  const onHandleChange = (e) => {
    setDescription(e.target.value);
  };

  const onSaveNew = () => {
    createNew({
      variables: {
        healthId: healthId,
        description: description,
      },
    });
  };

  return modalOpen ? (
    <Modal>
      <Content onClick={(event) => event.stopPropagation()}>
        <Close onClick={() => setModalOpen(false)}>
          <IconClose width={20} height={20} />
        </Close>
        <Title>Novedades</Title>
        <Description>Lleva control/Notas/recordatorios/Historial para este usuario.</Description>
        <ContainerInfo>
          <DivUp>
            <TextArea
              name="description"
              onChange={(e) => onHandleChange(e)}
              value={description}
              placeholder="Descripción"
              maxLength={250}
            />
            <PrimaryNormal
              title="Guardar"
              style={{ height: "30px", marginTop: 0, marginBottom: 0 }}
              onClick={onSaveNew}
            />
          </DivUp>
          <DivDown>
            {data?.getComments.map((item, index) => (
              <ContainerNote key={index}>{item.description}</ContainerNote>
            ))}
          </DivDown>
        </ContainerInfo>
      </Content>
    </Modal>
  ) : (
    <></>
  );
};

ModalNews.propTypes = {
  modalOpen: PropTypes.bool,
  setModalOpen: PropTypes.func,
  disabled: PropTypes.bool,
  healthId: PropTypes.string,
};

export default ModalNews;
